import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { ProfileHeader } from './ProfileHeader';
import { ProfileHeaderMobile } from './MobileView/ProfileHeaderMobile';

const ProfileHeaderWrapper: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {isMobile && (
                <>
                    <ProfileHeaderMobile />
                </>
            )}
            {!isMobile && (
                <>
                    {/*<TopHeaderNav />*/}
                    <ProfileHeader />
                </>
            )}
        </>
    );
};

export default React.memo(ProfileHeaderWrapper);
